import {Navigate, Routes, Route } from "react-router-dom";
import React from 'react'
import Layout from "./Layout";
import Home from "../pages/home/Home";
import Program from "../pages/programs/Program";
import Ignite from "../pages/programs/Ignite";
import Edge from "../pages/programs/edge";
import Elevate from "../pages/programs/elevate";
import Founder from "../pages/founder/Founder";
import Institution from "../pages/institution/Institution";
import About from "../pages/about/About";
import Contact from "../pages/contact/Contact";
import Blog from "../pages/blog/Blog";
import BlogDetail from "../pages/blog/BlogDetail";
import Error from "../pages/404/Error";
import Thankyou from "../pages/thankyou/Thankyou";
import Dynamic from "../pages/Dynamic/Dynamic";
import CorporateTeamBuilding from "../pages/CorporateTeamBuilding/CorporateTeamBuilding";
import CampusTeamBuilding from "../pages/CampusTeamBuilding/CampusTeamBuilding";

function Redirect({ to }) {
  if (typeof window !== "undefined") {
    // client-side
    return <Navigate to={to} replace />;
  }
  return null; // SSR just renders nothing
}

export default function NavRouter({ initialData }) {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="programs" element={<Program  initialData={initialData} />} />
          {/* <Route path="programs/ignite" element={<Ignite />} />
          <Route path="programs/edge" element={<Edge />} />
          <Route path="programs/elevate" element={<Elevate />} /> */}
          <Route path="founder" element={<Founder />} />
          <Route path="institution" element={<Institution  initialData={initialData} />} />
          <Route path="team-building" element={<Redirect to="/corporate-team-building" />} />
          <Route path="about-us" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="/:slug" element={<Dynamic initialData={initialData} />} />
          <Route path="corporate-team-building" element={<CorporateTeamBuilding />} />
          <Route path="campus-team-building" element={<CampusTeamBuilding />} />
          <Route path="dynamic-second" element={<Redirect to="/corporate-team-building" />} />
          <Route path="blogs" element={<Blog  initialData={initialData} />} />
          <Route path="blogs/:slug" element={<BlogDetail initialData={initialData} />} />
          <Route path='/404' element={<Error />} />
          <Route path="*" element={<Redirect to="/404" />} />
          <Route path="thank-you" element={<Thankyou />} />
        </Route>
      </Routes>
    </>
  );
}
